import isValidText from './isValidText';

export default function isValidServiceLevel(service) {
    return service && isValidText(service.label) && isValidText(service.name);
}
